import { Navigate, Route, Routes } from "react-router-dom";
import CCEActivities from "../screens/activities/cceActivities/CCEActivities";
import CHM from "../screens/activities/chmActivities/CHMPage";
import ICV from "../screens/activities/icvActivities/ICVPage";
import IEC from "../screens/activities/iecActivities/IECPage";
import VMS from "../screens/activities/icvActivities/vendorActivities/VMSPage";

export const PrivateRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/" element={<Navigate to="/chm" replace />} />
      <Route path="/chm" element={<CHM />} />
      <Route path="/icv" element={<ICV />} />
      <Route path="/iec" element={<IEC />} />
      <Route path="/vms" element={<VMS />} />
    </Routes>
  );
};
